 <template>
  <div class="app-contact">
    <div class="contacthead">
      <div class="container">
        <div class="row py-5">
          <div class="col-12 col-md-3 col-lg-3">
            <h3 class="contacttitle">Contact Us</h3>
          </div>
          <div class="col-12 col-md-7 col-lg-7">
            <!-- <p>Whether your vehicle needs its Service, MOT or additional maintenance our dealerships take pride in ensuring you receive a professional and simple service.</p> -->
            <p>It is our pleasure to assist you. For any inquires, send us an e-mail at info@silverstar-gh.com or call our hotline at (+233) 0244 335 558.</p>
          </div>
        </div>
      </div>
    </div>
    <!-- contactus form -->
    <div class>
      <div class="py-5">
        <div class="container">
          <div class>
            <div class="callbackFromMsg"></div>

            <form class id="callbackForm">
              <div class="row py-5">
                <div class="col-md-4 form-group">
                  <div style="display:flex">
                    <div class="contactnumber text-center">1</div>
                    <h5 class="contactoption">LEAVE A MESSAGE</h5>
                  </div>
                  <div style="margin:1.5rem 0rem">
                    <el-select
                      v-model="discuss"
                      size="small"
                      placeholder="I would like to discuss"
                      v-validate="'required'"
                    >
                      <el-option
                        v-for="item in option"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>

                    <span class="text-danger">{{ errors.first('discuss') }}</span>
                  </div>
                  <!-- <div style="margin:1.5rem 0rem">
                    <el-select
                      class="formcontrol"
                      size="small"
                      v-model="contactData.model"
                      placeholder="Model"
                    >
                      <el-option
                        v-for="item in models"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div> -->
                  <div style="margin:1.5rem 0rem">
                    <label for="textarea">Your Message</label>
                    <el-input
                      class="formcontrol"
                      type="textarea"
                      :rows="14"
                      maxlength="200"
                      v-model="contactData.message"
                    ></el-input>
                  </div>
                </div>
                <div class="col-md-4 form-group contactmiddle">
                  <div style="display:flex">
                    <div class="contactnumber text-center">2</div>
                    <h5 class="contactoption">ENTER YOUR CONTACT DETAILS</h5>
                  </div>
                  <div style="margin:0.5rem 0rem">
                    <label for="checkList">Titles*</label>
                    <br />
                    <input
                      type="checkbox"
                      class="check"
                      name="title"
                      value="Mr."
                      v-model="ptitle"
                      @change="onlyOne"
                    />
                    <label for="Mr." class="checkboxlabel">Mr.</label>

                    <input
                      type="checkbox"
                      class="check"
                      name="title"
                      value="Mrs."
                      v-model="ptitle"
                      @change="onlyOne"
                    />
                    <label for="Mrs." class="checkboxlabel">Mrs.</label>

                    <input
                      type="checkbox"
                      class="check"
                      name="title"
                      value="Miss."
                      v-model="ptitle"
                      @change="onlyOne"
                    />
                    <label for="Miss." class="checkboxlabel">Miss.</label>

                    <input
                      type="checkbox"
                      class="check"
                      name="title"
                      value="Ms."
                      v-model="ptitle"
                      @change="onlyOne"
                    />
                    <label for="Ms." class="checkboxlabel">Ms.</label>

                    <input
                      type="checkbox"
                      class="check"
                      name="title"
                      value="Dr."
                      v-model="ptitle"
                      @change="onlyOne"
                    />
                    <label for="Dr." class="checkboxlabel">Dr.</label>

                    <input
                      type="checkbox"
                      class="check"
                      name="title"
                      value="Others"
                      v-model="ptitle"
                      @change="onlyOne"
                    />
                    <label for="Others" class="checkboxlabel">Others</label>

                    <!-- <el-checkbox-group class="check" v-model="checkList" @change="onlyOne">
                      <el-checkbox label="Mr." class="check"></el-checkbox>
                      <el-checkbox label="Mrs." class="check"></el-checkbox>
                      <el-checkbox label="Miss." class="check"></el-checkbox>
                      <el-checkbox label="Ms." class="check"></el-checkbox>
                      <el-checkbox label="Dr." class="check"></el-checkbox>
                      <el-checkbox label="Others" class="check"></el-checkbox>
                    </el-checkbox-group>-->
                  </div>

                  <!-- firstname -->
                  <div style="margin:0.5rem 0rem">
                    <el-input
                      class="formcontrol"
                      name="fname"
                      id="fname"
                      size="small"
                      placeholder="First Name*"
                      v-model="contactData.fname"
                      v-validate="'required'"
                      data-vv-as="First Name"
                    ></el-input>
                    <span class="text-danger">{{ errors.first('fname') }}</span>
                  </div>
                  <!-- lastname -->
                  <div style="margin:0.5rem 0rem">
                    <el-input
                      class="formcontrol"
                      size="small"
                      placeholder="Last Name*"
                      name="lname"
                      id="lname"
                      v-model="contactData.lname"
                      v-validate="'required'"
                      data-vv-as="Last Name"
                    ></el-input>
                    <span class="text-danger">{{ errors.first('lname') }}</span>
                  </div>
                  <!-- email -->
                  <div style="margin:0.5rem 0rem">
                    <el-input
                      class="formcontrol"
                      size="small"
                      name="email"
                      id="email"
                      placeholder="Email Address*"
                      v-model="contactData.email"
                      v-validate="'required'"
                      data-vv-as="Email Address"
                    ></el-input>
                    <span class="text-danger">{{ errors.first('email') }}</span>
                  </div>
                  <!-- phone -->
                  <div style="margin:0.5rem 0rem">
                    <el-input
                      class="formcontrol"
                      size="small"
                       name="phone"
                      id="phone"
                      placeholder="Phone*"
                       v-validate="'required'"
                      data-vv-as="Phone"
                      v-model="contactData.phone"
                    ></el-input>
                      <span class="text-danger">{{ errors.first('phone') }}</span>
                  </div>
                  <!-- address -->
                  <div style="margin:0.5rem 0rem">
                    <el-input
                      class="formcontrol"
                      size="small"
                        name="address"
                      id="address"
                      placeholder="Address"
                      
                      data-vv-as="Address"
                      v-model="contactData.address"
                    ></el-input>
                       <span class="text-danger">{{ errors.first('address') }}</span>
                  </div>
                  <!-- zip code -->
                  <div style="margin:0.5rem 0rem">
                    <el-input
                      class="formcontrol"
                       name="po"
                      size="small"
                      placeholder="P.O BOX"
                      
                      data-vv-as="P.O BOX"
                      v-model="contactData.zipcode"
                    ></el-input>
                     <span class="text-danger">{{ errors.first('po') }}</span>
                  </div>
                  <!-- city -->
                  <div style="margin:0.5rem 0rem">
                    <el-input
                      class="formcontrol"
                       name="city"
                      size="small"
                      placeholder="City*"
                      v-validate="'required'"
                      data-vv-as="City"
                      v-model="contactData.city"
                    ></el-input>
                     <span class="text-danger">{{ errors.first('city') }}</span>
                  </div>
                  <p>* Mandatory fields</p>
                  <input
                    type="checkbox"
                    class="check"
                    id="check"
                    name="subscribe"
                    value="Subscribe to our newsletter"
                    v-model="subscribe"
                    @change="sub"
                  />
                  <label for="subscribe" class="checkboxlabel">Subscribe to our newsletter</label>
                  <br />

                  <input
                    type="checkbox"
                    class="check"
                    id="check1"
                    name="update"
                    value="Stay updated via phone"
                    v-model="update"
                    @change="upd"
                  />
                  <label for="update" class="checkboxlabel">Stay updated via phone</label>

                  <!-- <input type="checkbox" v-model="subscribe" name="subscribe" value="Subscribe to our newsletter">Subscribe to our newsletter</el-checkbox>
                  <el-checkbox v-model="update" name="stay" value="Stay updated via phone">Stay updated via phone</el-checkbox>-->
                </div>
                <div class="col-md-4 form-group">
                  <div style="display:flex">
                    <div class="contactnumber text-center">3</div>
                    <h5 class="contactoption">Select your BRANCH</h5>
                  </div>
                  <div style="margin:1.5rem 0rem">
                    <el-select
                      class="formcontrol"
                      size="small"
                      v-model="branch"
                      name="branch"
                      placeholder="Select City"
                      v-validate="'required'"
                      data-vv-as="Branch"
                    >
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                  <div>
                    <button
                      class="btn btn-success"
                      v-on:click.prevent="contactFormSubmitFxn($event)"
                    >
                      <span>SEND MESSAGE</span>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="contactus">
      <!-- location -->
      <div class="container">
        <div class="location" style>
          <h6>Accra</h6>
        </div>
      </div>

      <div class="container">
        <div class="row mb-5">
          <div class="col-sm-6 col-md-4 col-lg-4">
            <div class="pb-3 conposition">
              <h6>Head Office</h6>
              <div>
                <p>
                  Location: Graphic Road,
                  <br />Kaneshie,
                  Accra, P.O. Box 502
                </p>
              </div>

              <div>
                <p>Hotline: (+233) 0244 335 558</p>
              </div>

              <p>
                Tel: (+233) 0244 334 274
                <br />
                <span style="padding-left:1.5rem">(+233) 0244 309 657</span>
                <br />
                <br />Email: info@silverstar-gh.com
                <br />GPS Address: GA 176-5556
                <!-- <br />Accra, Ghana -->
              </p>
            </div>
          </div>

          <!-- 2 -->
          <div class="col-sm-6 col-md-4 col-lg-4">
            <div class="pb-3 conposition">
              <h6>Service Centre/After-Sales</h6>
              <div>
                <p>
                  Location: Graphic Road,
                  <br />Kaneshie,Accra, P.O. Box 502
                </p>
              </div>
              <div>
                <p>Hotline: (+233) 0244 334 273</p>
              </div>
              <p>
                Tel: (+233) 0244 334 273
                <br />
                <span style="padding-left:1.5rem">(+233) 0243 600 661</span>
                <br />
                <span style="padding-left:1.5rem">(+233) 0556 599 985</span>
                <br />
                <br />Email: workshop.accra@silverstar-gh.com
                <br />GPS Address: GA 176-5556
                <!-- <br />Accra, Ghana -->
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="location" style="margin-top: 3rem !important;">
        <h6>Showrooms</h6>
      </div>
    </div>
    <div class="container">
      <div class="row mb-5 contactus">
        <div class="col-sm-6 col-md-4 col-lg-4">
          <div class="pb-3 conposition">
            <h6>Peugeot Showroom</h6>

            <div>
              <p>
                Location: Graphic Road,
                <br />Kaneshie, Adjacent Total Filling Station,
                <br />Accra, P.O. Box 502
              </p>
            </div>
            <div>
              <p>Hotline: (+233) 0243 600 664</p>
            </div>

            <p>
              Tel: (+233) 0244 334 274
              <br />
              <br />Email: info@silverstar-gh.com
              <br />GPS Address: GA-176-6938
              <!-- <br />Accra, Ghana -->
            </p>
          </div>
        </div>
        <!-- 2 -->
        <div class="col-sm-6 col-md-4 col-lg-4">
          <div class="pb-3 conposition">
            <h6>Citroën Showroom</h6>

            <div>
              <p>
                Location: Graphic Road,
                <br />Kaneshie, Accra, P.O. Box 502
              </p>
            </div>
            <div>
              <p>Hotline: (+233) 0544 336 869</p>
            </div>

            <p>
              Tel: (+233) 0302 244 309 657
              <br />
              <br />Email: info@silverstar-gh.com
              <br />GPS Address: GA 176-5556
            </p>
          </div>
        </div>
        <div class="col-sm-6 col-md-4 col-lg-4">
          <div class="pb-3 conposition">
            <h6>Mercedes-Benz Showroom</h6>
            <div>
              <p>
                Location: Silver Star Towers, Airport,
                <br />Accra P.O. Box DTD 192
              </p>
            </div>
            <div>
              <p>Hotline: (+233) 0203 300 752</p>
            </div>

            <p>
              Tel: (+233) 0302 768 849
              <br />
              <span style="padding-left:1.5rem">(+233) 0302 768 851</span>
              <br />
              <br />Email: info@silverstar-gh.com
              <br />GPS Address: GL-116-3457
              <!-- <br />Accra, Ghana -->
            </p>
          </div>
        </div>
        <!-- <div class="col-sm-6 col-md-4 col-lg-4"></div> -->
      </div>
    </div>
    <!-- second -->
    <div class="contactus">
      <!-- location -->
      <div class="container">
        <div class="location" style="margin-top: 3rem !important;">
          <h6>Tema</h6>
        </div>
      </div>

      <div class="container">
        <div class="row mb-5">
          <div class="col-sm-6 col-md-4 col-lg-4">
            <div class="pb-3 conposition">
              <h6>Head Office</h6>
              <div>
                <p>
                  Location: Cocoa Processing Road, Comm. 1,
                  <br />P.O. BOX 199, Tema
                </p>
              </div>

              <div>
                <p>Hotline: (+233) 0244 334 524</p>
              </div>

              <p>
                Tel: (+233) 0303 200 596
                <br />
                <br />Email: cv.sales@silverstar-gh.com
                <br />GPS Address: GT-002-7587
              </p>
            </div>
          </div>

          <!-- 2 -->
          <div class="col-sm-6 col-md-4 col-lg-4">
            <div class="pb-3 conposition">
              <h6>Service Centre/After-Sales</h6>
              <div>
                <p>
                  Location: Cocoa Processing Road, Comm. 1,
                  <br />P.O. BOX 199, Tema
                </p>
              </div>
              <div>
                <p>
                  Hotline: (+233) 0244 334 524
                  <br />
                </p>
              </div>
              <p>
                Tel: (+233) 0303 200 596
                <br />
                <br />Email: workshop@silverstar-gh.com
                <br />GPS Address: GT-002-7587
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- third -->
    <div class="contactus">
      <!-- location -->
      <div class="container">
        <div class="location" style="margin-top: 3rem !important;">
          <h6>Kumasi</h6>
        </div>
      </div>

      <div class="container">
        <div class="row mb-5">
          <div class="col-sm-6 col-md-4 col-lg-4">
            <div class="pb-3 conposition">
              <h6>Head Office</h6>
              <div>
                <p>
                  Location: Prempeh Street, Adum,
                  <br />Kumasi, P.O. Box 6015
                </p>
              </div>

              <div>
                <p>
                  Hotline : (+233) 0556 490 450
                  <br />
                </p>
              </div>

              <p>
                Tel: (+233) 0556 490 450
                <br />
                <br />Email: info@silverstar-gh.com
                <br />GPS Address: AK-065-9833
              </p>
            </div>
          </div>

          <!-- 2 -->
          <div class="col-sm-6 col-md-4 col-lg-4">
            <div class="pb-3 conposition">
              <h6>Service Centre/After-Sales</h6>
              <div>
                <p>
                  Location: Prempeh Street, Adum,
                  <br />Kumasi, P.O. Box 6015
                </p>
              </div>
              <div>
                <p>Hotline : (+233) 0556 490 450</p>
              </div>
              <p>
                Tel: (+233) 0556 490 450
                <br />
                <br />Email: enartey@silverstar-gh.com
                <br />GPS Address: AK-065-9833
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="contactus pb-5">
      <div class="container">
        <div class="location" style="margin-top: 3rem !important;">
          <h6>Working Hours</h6>
        </div>
        <div class>
          <div class="row pb-3 conposition">
            <div class="col-sm-6 col-lg-1 workinghrs" style>
              <span style="font-weight:bold">Monday</span>

              <br />
              <p>7:30am–4:30pm</p>
            </div>
            <div class="col-sm-6 col-lg-1 workinghrs" style>
              <span style="font-weight:bold">Tuesday</span>
              <br />
              <p>7:30am–4:30pm</p>
            </div>
            <div class="col-sm-6 col-lg-1 workinghrs" style>
              <span style="font-weight:bold">Wednesday</span>
              <br />
              <p>7:30am–4:30pm</p>
            </div>
            <div class="col-sm-6 col-lg-1 workinghrs" style>
              <span style="font-weight:bold">Thursday</span>
              <br />
              <p>7:30am–4:30pm</p>
            </div>
            <div class="col-sm-6 col-lg-1 workinghrs" style>
              <span style="font-weight:bold">Friday</span>
              <br />
              <p>7:30am–5pm</p>
            </div>
            <div class="col-sm-6 col-lg-1 workinghrs" style>
              <span style="font-weight:bold">Saturday</span>
              <br />
              <p>9am-2pm</p>
            </div>
            <div class="col-sm-6 col-lg-1 workinghrs" style>
              <span style="font-weight:bold">Sunday</span>
              <br />
              <p>Closed</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bg-dark" style="padding-top:3rem">
      <div class="container">
        <core style="border-top:1px solid rgba(255, 255, 255, .24)"></core>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import CoreValues from "../components/Core.vue";
const cityOptions = ["Shanghai", "Beijing", "Guangzhou", "Shenzhen"];

export default {
  name: "contact",
  components: {
    core: CoreValues
  },
  data() {
    return {
      cities: ["Shanghai", "Beijing", "Guangzhou", "Shenzhen"],
      checkList: ["selected and disabled", "Option A"],
      subscribe: "",
      update: "",
      options: [
        {
          value: "Accra",
          label: "Accra"
        },
        {
          value: "Tema",
          label: "Tema"
        },
        {
          value: "Kumasi",
          label: "Kumasi"
        }
      ],
      branch: "",
      option: [
        {
          value: "Peugeot",
          label: "Peugeot"
        },
        {
          value: "Citroën",
          label: "Citroën"
        },
        {
          value: "Mercedes-Benz Passenger",
          label: "Mercedes-Benz Passenger"
        },
        // {
        //   value: "Mercedes-Benz Commercial",
        //   label: "Mercedes-Benz Commercial"
        // },
        {
          value: "After-Sales",
          label: "After-Sales"
        },
        {
          value: "General Inquiry",
          label: "General Inquiry"
        },
        {
          value: "Complaints & Feedback",
          label: "Complaints & Feedback"
        }
      ],
      discuss: "",
      models: [],
      model: "",
      ptitle: [],
      contactData: {
        fname: "",
        lname: "",
        phone: "",
        email: "",
        address: "",
        message: "",
        zipcode: "",
        city: ""
      }
    };
  },
  metaInfo() {
    return {
      title: "Contact"
    };
  },
  computed: {},
  methods: {
    onlyOne(e) {
      // $(".check")
      //   .not(this)
      //   .prop("checked", false);
      this.ptitle = [];
      if (e.target.checked) {
        this.ptitle.push(e.target.value);
      }
    },
    sub(e) {
      this.subscribe = "";
      //  if (e.target.checked) {
      //     this.subscribe.push(e.target.value);}
      this.subscribe = $("#check").val();
    },
    upd(e) {
      this.update = "";
      //  if (e.target.checked) {
      //     this.update.push(e.target.value);}
      this.update = $("#check1").val();
    },
    onChange() {
      switch (this.brand) {
        case "Peugeot":
          console.log("new p" + this.brand);

          this.models = [
            {
              value: "5008 SUV",
              label: "5008 SUV"
            },
            {
              value: "3008 SUV",
              label: "3008 SUV"
            },
            {
              value: "301 Saloon",
              label: "301 Saloon"
            },
            {
              value: "KP0 Pickup",
              label: "KP0 Pickup"
            }
          ];
          break;
        case "Mercedes":
          console.log("new m" + this.brand);
          $(".model1").css("display", "none");
          $(".model").css("display", "block");

          break;
        case "Citroën":
          console.log("new c" + this.brand);
          this.models = [
            {
              value: "C4 Cactus",
              label: "C4 Cactus"
            },
            {
              value: "C5 Aircross",
              label: "C5 Aircross"
            },
            {
              value: "Berlingo Van ",
              label: "Berlingo Van "
            },
            {
              value: "Berlingo Passanger ",
              label: "Berlingo Passanger "
            },
            {
              value: "Jumper Van",
              label: "Jumper Van "
            },
            {
              value: "Jumper Passenger",
              label: "Jumper Passenger"
            }
          ];
          break;
      }
    },
    contactFormSubmitFxn(e) {
      console.log("subscribe " + this.subscribe);
      console.log("update " + this.update);
      console.log("title " + this.ptitle);
      var btn = e.currentTarget;
      var sve = document.querySelector(".s-v-e");
      if (sve) sve.remove();

      this.$validator.validateAll().then(result => {
        if (result) {
          var contactFormData = {
            fname: this.contactData.fname,
            lname: this.contactData.lname,
            email: this.contactData.email,
            phone: this.contactData.phone,
            address: this.contactData.address,
            message: this.contactData.message,
            zipcode: this.contactData.zipcode,
            city: this.contactData.city,
            branch: this.branch,
            title: this.ptitle,
            subscribe: this.subscribe,
            update: this.update,
            discuss: this.discuss
          };

          contactFormData = JSON.stringify(contactFormData);

          axios.interceptors.request.use(function(arg) {
            btn.innerHtml = '<i class="fa fa-spinner fa-spin fa-fw"></i>';
            return arg;
          });
          javascript:window.adf&&adf.ClickTrack(this,2867926,'Ghana Silverstar Request a quote Landtrek',{});	
          axios
            .post(APIURL + "contact", contactFormData)
            .then(response => {
              var res = response.data;
              btn.innerHTML = "SEND MESSAGE";
              if (res.status === true) {
                var responseMsg = document.querySelector(".callbackFromMsg");
                var html = `<div class="alert alert-success alert-dismissible fade show" role="alert">
                                                ${res.msg}
                                                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>`;
                responseMsg.classList.add("my-3");
                responseMsg.innerHTML = html;

                this.contactData.fname = "";
                this.contactData.lname = "";
                this.contactData.phone = "";
                this.contactData.email = "";

                this.contactData.address = "";
                this.contactData.message = "";
                this.contactData.zipcode = "";
                this.contactData.city = "";
                this.branch = "";
                this.title = "";
                this.subscribe = "";
                this.update = "";
                this.discuss = "";

                this.$validator.reset();
              } else {
                if (res.status === "validation_errors") {
                  res.errors.forEach((k, v) => {
                    document.querySelector(`#${k}`).appendChild(v);
                  });
                } else {
                  var responseMsg = document.querySelector(".callbackFromMsg");
                  var html = `<div class="alert alert-danger alert-dismissible fade show" role="alert">
                                                ${res.msg}
                                                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>`;
                  responseMsg.classList.add("my-3");
                  responseMsg.innerHTML = html;

                  this.contactData.fname = "";
                  this.contactData.lname = "";
                  this.contactData.phone = "";
                  this.contactData.email = "";

                  this.contactData.address = "";
                  this.contactData.message = "";
                  this.contactData.zipcode = "";
                  this.contactData.city = "";
                  this.branch = "";
                  this.title = "";
                  this.subscribe = "";
                  this.update = "";
                  this.discuss = "";

                  this.$validator.reset();
                }
              }
            })
            .catch(err => {
              console.log(err);
            });
        }
      });
    }
  },
  created() {}
};
</script>
